import React, { useEffect, useState } from "react";
import { getData } from "../../Tools/helpers";

import FormCustom from "../../components/FormCustom";
import TableCustom from "../../components/TableCustom";

const University = () => {
  const [dataTable, setDataTable] = useState([]);
  const [dataForm, setDataForm] = useState({});
  const [isTrueUpdateData, setIsTrueUpdateData] = useState(false);
  const [isTrueDeleteData, setIsTrueDeleteData] = useState(false);

  const FieldsCustom = [
    { name: "name", label: "Campus", required: "true" },
    { name: "short_name", label: "Nombre Corto", required: "false" },
    { name: "address", label: "Dirección", required: "false" },
    { name: "phone", label: "Teléfono", required: "false" },
    { name: "email", label: "Email", required: "false" },
  ];

  const routeForm = "University";

  const getUniversities = async () => {
    const route = routeForm;
    const send = await getData(route);
    console.log(send);
    if (send.code === 200) {
      setDataTable(send.data);
    }
  };

  useEffect(() => {
    getUniversities();
  }, []);

  return (
    <div className="flex-1">
      <div className=" mb-10 max-w-2xl">
        <FormCustom
          fields={FieldsCustom}
          title="DATOS DEL CAMPUS"
          route={routeForm}
          method="post"
          setData={setDataForm}
          data={dataForm}
          fieldDialog="name"
          setIsTrueUpdateData={setIsTrueUpdateData}
          isTrueUpdateData={isTrueUpdateData}
          refreshDataList={getUniversities}
          setIsTrueDeleteData={setIsTrueDeleteData}
          isTrueDeleteData={isTrueDeleteData}
        />
      </div>
      <div className="flex-1">
        <TableCustom
          fields={FieldsCustom}
          setDataForm={setDataForm}
          data={dataTable}
          setIsTrueUpdateData={setIsTrueUpdateData}
          setIsTrueDeleteData={setIsTrueDeleteData}
        />
      </div>
    </div>
  );
};

export default University;
